import React from "react";
import { ClipLoader } from "react-spinners";
import PropTypes from "prop-types";
import "./Loader.scss";

const Loader = ({ loading, size = 50, color = "#36d7b7", fullscreen = false }) => {
    return (
        <>
            {loading && (
                <div className={fullscreen ? "loader-wrapper loader-fullscreen" : "loader-wrapper"}>
                    <ClipLoader loading={loading} size={size} color={color} />
                </div>
            )}
        </>
    );
};

Loader.propTypes = {
    loading: PropTypes.bool.isRequired,
    size: PropTypes.number,
    color: PropTypes.string,
    fullscreen: PropTypes.bool,
};

export default Loader;
